export const formatAnalyticsMoney = (value: number | null | undefined): string =>
  `${(typeof value === 'number' && Number.isFinite(value) ? value : 0).toLocaleString('uk-UA', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })} грн`;

export const formatAnalyticsMargin = (value: number | null | undefined): string =>
  typeof value === 'number' && Number.isFinite(value) ? `${value.toFixed(1)}%` : '—';

export const analyticsStatusLabel = (confirmed: boolean): string => (confirmed ? 'Підтверджено' : 'Попередньо');

export const formatLocalDateInput = (date: Date): string => {
  const pad = (value: number) => String(value).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
};
